import { useState, useEffect, useRef } from "react";

const TODAY = new Date();
const fmt = d => d.toISOString().split("T")[0];
const LEAVE_TYPES = ["Congé payé", "Maladie", "Sans solde", "Familial", "Autre"];
const STATUSES = ["Approuvé", "En attente", "Refusé"];
const CONTRACT_TYPES = ["SIVP", "CDD", "CDI", "Freelance"];
const CONTRACT_COLORS = { SIVP:{bg:"#f5f3ff",c:"#7c3aed"}, CDD:{bg:"#eff6ff",c:"#1e40af"}, CDI:{bg:"#dcfce7",c:"#16a34a"}, Freelance:{bg:"#fff7ed",c:"#d97706"} };

function monthsDiff(from, to) {
  const f = new Date(from), t = new Date(to);
  return Math.max(0, (t.getFullYear() - f.getFullYear()) * 12 + (t.getMonth() - f.getMonth()));
}
function yearsDiff(from, to) {
  const f = new Date(from), t = new Date(to);
  return Math.max(0, t.getFullYear() - f.getFullYear() + (
    (t.getMonth() > f.getMonth() || (t.getMonth() === f.getMonth() && t.getDate() >= f.getDate())) ? 0 : -1
  ));
}
function getWorkingDays(s, e, paidHolis = new Set()) {
  if (!s || !e) return 0;
  let count = 0;
  const d = new Date(s + "T12:00:00");
  const end = new Date(e + "T12:00:00");
  while (d <= end) {
    const wd = d.getDay();
    if (wd !== 0 && wd !== 6) {
      const ds = d.toISOString().split("T")[0];
      if (!paidHolis.has(ds)) count++;
    }
    d.setDate(d.getDate() + 1);
  }
  return count;
}
const getRecordDays = (r, holidays = []) => {
  if (r.halfDay) return 0.5;
  // Les jours fériés payés ne sont exclus que pour les Congés Payés
  const paidSet = r.type === "Congé payé"
    ? new Set(holidays.filter(h => h.paid).map(h => h.date))
    : new Set();
  return getWorkingDays(r.start, r.end, paidSet);
};

const initParams = { cpRate: 1.75, malRate: 3 };
const initEmployees = [
  { name: "Employé 1", hireDate: "2024-01-01", pin: "1111", active: true, employed: true, leaveDate: "", leaveCause: "", contracts: [{ id:1, type:"CDI", startDate:"2024-01-01", endDate:"", note:"" }] },
  { name: "Employé 2", hireDate: "2024-03-15", pin: "2222", active: true, employed: true, leaveDate: "", leaveCause: "", contracts: [{ id:2, type:"CDD", startDate:"2024-03-15", endDate:"2025-03-15", note:"1 an" }, { id:3, type:"CDI", startDate:"2025-03-16", endDate:"", note:"" }] },
  { name: "Employé 3", hireDate: "2025-06-01", pin: "3333", active: true, employed: true, leaveDate: "", leaveCause: "", contracts: [{ id:4, type:"SIVP", startDate:"2025-06-01", endDate:"", note:"" }] },
  { name: "Employé 4", hireDate: "2023-09-10", pin: "4444", active: true, employed: true, leaveDate: "", leaveCause: "", contracts: [{ id:5, type:"CDD", startDate:"2023-09-10", endDate:"2024-09-10", note:"" }, { id:6, type:"CDI", startDate:"2024-09-11", endDate:"", note:"" }] },
];
const initLeaves = initEmployees.map(e => ({ name: e.name, records: [] }));

const Badge = ({ s }) => {
  const c = s==="Approuvé"?["#dcfce7","#16a34a"]:s==="Refusé"?["#fee2e2","#dc2626"]:["#fef9c3","#ca8a04"];
  return <span style={{ padding:"2px 10px", borderRadius:99, fontSize:11, fontWeight:700, background:c[0], color:c[1] }}>{s}</span>;
};

const Input = ({label, ...props}) => (
  <div>
    {label && <label style={{ fontSize:11, color:"#64748b", display:"block", marginBottom:3 }}>{label}</label>}
    <input {...props} style={{ width:"100%", padding:"7px 10px", border:"1px solid #cbd5e1", borderRadius:6, fontSize:13, boxSizing:"border-box", ...(props.style||{}) }} />
  </div>
);

const ContractBadge = ({ type }) => {
  const col = CONTRACT_COLORS[type] || { bg:"#f1f5f9", c:"#64748b" };
  return <span style={{ padding:"1px 7px", borderRadius:99, fontSize:10, fontWeight:800, background:col.bg, color:col.c, border:`1px solid ${col.c}33` }}>{type}</span>;
};

// ─── PORTAIL EMPLOYÉ ───
function EmployeeView({ emp, leaveData, refDate, params, holidays, onBack }) {
  const months = monthsDiff(emp.hireDate, refDate);
  const years = yearsDiff(emp.hireDate, refDate);
  const refYear = refDate.slice(0,4);
  const startOfYear = `${refYear}-01-01`;
  const malFrom = emp.hireDate > startOfYear ? emp.hireDate : startOfYear;
  const cpAcq = +(months * params.cpRate).toFixed(2);
  const malAcq = +(monthsDiff(malFrom, refDate) * (params.malRate/12)).toFixed(2);
  const cpPris = leaveData.records.filter(r=>r.type==="Congé payé"&&r.status==="Approuvé").reduce((s,r)=>s+getRecordDays(r,holidays),0);
  const malPris = leaveData.records.filter(r=>r.type==="Maladie"&&r.status==="Approuvé"&&r.start?.startsWith(refYear)).reduce((s,r)=>s+getRecordDays(r,holidays),0);
  const cpSolde = +(cpAcq - cpPris).toFixed(2);
  const malSolde = +(malAcq - malPris).toFixed(2);

  return (
    <div style={{ fontFamily:"Segoe UI,sans-serif", maxWidth:700, margin:"0 auto", padding:24, background:"#f0f4f8", minHeight:"100vh" }}>
      <div style={{ background:"linear-gradient(135deg,#1e40af,#3b82f6)", borderRadius:14, padding:"22px 26px", marginBottom:22, color:"#fff" }}>
        <button onClick={onBack} style={{ background:"rgba(255,255,255,0.2)", border:"none", color:"#fff", borderRadius:6, padding:"5px 12px", cursor:"pointer", fontSize:12, marginBottom:12 }}>← Retour</button>
        <div style={{ display:"flex", alignItems:"center", gap:16 }}>
          <div style={{ width:52, height:52, borderRadius:"50%", background:"rgba(255,255,255,0.25)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:22, fontWeight:800 }}>{emp.name[0]}</div>
          <div>
            <h2 style={{ margin:0, fontSize:20 }}>{emp.name}</h2>
            <p style={{ margin:"4px 0 0", opacity:.8, fontSize:12 }}>Embauché le {emp.hireDate} · {months} mois · {years} an(s)</p>
        <p style={{ margin:"4px 0 0", opacity:.65, fontSize:11 }}>📋 CP : {params.cpRate} j/mois · Maladie : {params.malRate} j/an progressif</p>
          </div>
        </div>
      </div>

      {/* CP Card */}
      <div style={{ background:"#fff", borderRadius:10, padding:18, marginBottom:14, boxShadow:"0 1px 4px #0001" }}>
        <h3 style={{ margin:"0 0 12px", fontSize:14, color:"#1e293b" }}>🌴 Congés Payés <span style={{ fontSize:11, color:"#94a3b8", fontWeight:400 }}>({params.cpRate} j/mois)</span></h3>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:10, marginBottom:12 }}>
          {[{l:"Acquis",v:cpAcq,c:"#0369a1"},{l:"Pris",v:cpPris,c:"#d97706"},{l:"Solde",v:cpSolde,c:cpSolde<0?"#dc2626":"#16a34a",bold:true}].map(x=>(
            <div key={x.l} style={{ textAlign:"center", padding:10, background:"#f8fafc", borderRadius:8, border:x.bold?"2px solid #bbf7d0":"none" }}>
              <div style={{ fontSize:22, fontWeight:800, color:x.c }}>{x.v}</div>
              <div style={{ fontSize:11, color:"#64748b" }}>{x.l}</div>
            </div>
          ))}
        </div>
        <div style={{ background:"#e2e8f0", borderRadius:99, height:8 }}>
          <div style={{ width:`${cpAcq>0?Math.min(100,Math.round(cpPris/cpAcq*100)):0}%`, background:"#3b82f6", height:8, borderRadius:99, transition:"width .4s" }} />
        </div>
      </div>

      {/* Maladie Card */}
      <div style={{ background:"#fff", borderRadius:10, padding:18, marginBottom:14, boxShadow:"0 1px 4px #0001" }}>
        <h3 style={{ margin:"0 0 12px", fontSize:14, color:"#1e293b" }}>🏥 Congés Maladie <span style={{ fontSize:11, color:"#94a3b8", fontWeight:400 }}>({params.malRate} j/an · remise à zéro chaque année)</span></h3>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:10, marginBottom:12 }}>
          {[{l:"Acquis",v:malAcq,c:"#7c3aed"},{l:"Pris",v:malPris,c:"#d97706"},{l:"Solde",v:malSolde,c:malSolde<0?"#dc2626":"#7c3aed",bold:true}].map(x=>(
            <div key={x.l} style={{ textAlign:"center", padding:10, background:"#f8fafc", borderRadius:8, border:x.bold?"2px solid #e9d5ff":"none" }}>
              <div style={{ fontSize:22, fontWeight:800, color:x.c }}>{x.v}</div>
              <div style={{ fontSize:11, color:"#64748b" }}>{x.l}</div>
            </div>
          ))}
        </div>
        {malSolde < 0 && <div style={{ background:"#fee2e2", borderRadius:6, padding:"8px 12px", fontSize:12, color:"#dc2626" }}>⚠️ {Math.abs(malSolde)} jour(s) de maladie au-delà du solde acquis</div>}
      </div>

      {/* Contrats */}
      <div style={{ background:"#fff", borderRadius:10, padding:18, marginBottom:14, boxShadow:"0 1px 4px #0001" }}>
        <h3 style={{ margin:"0 0 12px", fontSize:14, color:"#1e293b" }}>📄 Contrats <span style={{ fontSize:11, color:"#94a3b8", fontWeight:400 }}>· Embauché le {emp.hireDate}</span></h3>
        {(!emp.contracts || emp.contracts.length === 0) ? (
          <div style={{ color:"#94a3b8", textAlign:"center", padding:16, fontSize:13 }}>Aucun contrat enregistré</div>
        ) : (
          <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
            {emp.contracts.map((c, i) => {
              const col = CONTRACT_COLORS[c.type] || { bg:"#f1f5f9", c:"#64748b" };
              const isCurrent = !c.endDate || c.endDate === "";
              return (
                <div key={c.id || i} style={{ display:"flex", alignItems:"center", gap:12, padding:"10px 14px", borderRadius:8, background:col.bg, border:`1px solid ${col.c}33` }}>
                  <ContractBadge type={c.type} />
                  <div style={{ flex:1 }}>
                    <span style={{ fontSize:13, color:"#1e293b", fontWeight:600 }}>Depuis le {c.startDate}</span>
                    {c.endDate && <span style={{ fontSize:12, color:"#64748b" }}> → {c.endDate}</span>}
                    {c.note && <span style={{ fontSize:11, color:"#94a3b8", marginLeft:8 }}>({c.note})</span>}
                  </div>
                  {isCurrent && <span style={{ fontSize:10, fontWeight:700, padding:"2px 8px", borderRadius:99, background:"#dcfce7", color:"#16a34a" }}>En cours</span>}
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* Historique */}
      <div style={{ background:"#fff", borderRadius:10, padding:18, boxShadow:"0 1px 4px #0001" }}>
        <h3 style={{ margin:"0 0 12px", fontSize:14 }}>📋 Historique</h3>
        {leaveData.records.length===0 ? (
          <div style={{ color:"#94a3b8", textAlign:"center", padding:24 }}>Aucun congé enregistré</div>
        ) : (
          <table style={{ width:"100%", borderCollapse:"collapse", fontSize:13 }}>
            <thead><tr style={{ background:"#f1f5f9" }}>
              {["Type","Début","Fin","Jours","Statut"].map(h=><th key={h} style={{ padding:"7px 10px", textAlign:"left", color:"#475569", fontWeight:600, fontSize:12 }}>{h}</th>)}
            </tr></thead>
            <tbody>
              {leaveData.records.map((r,i)=>(
                <tr key={i} style={{ borderBottom:"1px solid #f1f5f9" }}>
                  <td style={{ padding:"7px 10px" }}>{r.type}</td>
                  <td style={{ padding:"7px 10px" }}>{r.start}{r.halfDay&&<span style={{ marginLeft:4, padding:"1px 5px", borderRadius:99, fontSize:10, fontWeight:700, background:"#fef9c3", color:"#ca8a04" }}>½ j</span>}</td>
                  <td style={{ padding:"7px 10px" }}>{r.halfDay?"-":r.end}</td>
                  <td style={{ padding:"7px 10px", fontWeight:700, color:"#1e40af" }}>{getRecordDays(r,holidays)}</td>
                  <td style={{ padding:"7px 10px" }}><Badge s={r.status}/></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

function EmployeeLogin({ employees, leaveData, refDate, params, holidays, onBack }) {
  const [sel, setSel] = useState("");
  const [pin, setPin] = useState("");
  const [err, setErr] = useState("");
  const [authed, setAuthed] = useState(null);
  const login = () => {
    const emp = employees.find(e=>e.name===sel);
    if (!emp){setErr("Sélectionnez un employé.");return;}
    if (!emp.active){setErr("❌ Compte désactivé. Contactez l'administrateur.");return;}
    if (emp.pin!==pin){setErr("❌ Code incorrect.");return;}
    setAuthed(emp);
  };
  const selEmp = employees.find(e=>e.name===sel);
  if (authed) {
    const ld = leaveData.find(l=>l.name===authed.name)||{name:authed.name,records:[]};
    return <EmployeeView emp={authed} leaveData={ld} refDate={refDate} params={params} holidays={holidays} onBack={()=>setAuthed(null)} />;
  }
  return (
    <div style={{ fontFamily:"Segoe UI,sans-serif", maxWidth:400, margin:"60px auto", padding:24 }}>
      <div style={{ background:"#fff", borderRadius:14, padding:32, boxShadow:"0 4px 24px #0002", textAlign:"center" }}>
        <div style={{ fontSize:46, marginBottom:8 }}>🔐</div>
        <h2 style={{ margin:"0 0 4px", color:"#1e293b" }}>Portail Employé</h2>
        <p style={{ color:"#64748b", fontSize:13, marginBottom:22 }}>Consultez votre solde & historique</p>
        <select value={sel} onChange={e=>{setSel(e.target.value);setErr("")}}
          style={{ width:"100%", padding:"10px 12px", border:"1px solid #cbd5e1", borderRadius:8, fontSize:14, marginBottom:10, background:"#f8fafc" }}>
          <option value="">-- Sélectionnez votre nom --</option>
          {employees.filter(e=>e.active).map(e=><option key={e.name} value={e.name}>{e.name}{!e.employed?" (A quitté)":""}</option>)}
        </select>
        {selEmp && !selEmp.employed && (
          <div style={{ background:"#fff7ed", border:"1px solid #f97316", borderRadius:6, padding:"8px 12px", fontSize:12, color:"#ea580c", marginBottom:10 }}>
            📋 Cet employé a quitté l'entreprise. Vous pouvez consulter votre historique en lecture seule.
          </div>
        )}
        <input type="password" placeholder="🔑 Code PIN" value={pin} onChange={e=>{setPin(e.target.value);setErr("")}}
          onKeyDown={e=>e.key==="Enter"&&login()}
          style={{ width:"100%", padding:"10px 12px", border:"1px solid #cbd5e1", borderRadius:8, fontSize:14, marginBottom:14, boxSizing:"border-box", textAlign:"center", letterSpacing:6 }} />
        {err&&<div style={{ color:"#dc2626", fontSize:13, marginBottom:10 }}>{err}</div>}
        <button onClick={login} style={{ width:"100%", background:"#1e40af", color:"#fff", border:"none", borderRadius:8, padding:12, fontWeight:700, fontSize:15, cursor:"pointer" }}>Accéder →</button>
        <button onClick={onBack} style={{ marginTop:12, background:"none", border:"none", color:"#94a3b8", cursor:"pointer", fontSize:13 }}>← Retour accueil</button>
      </div>
    </div>
  );
}

function HistoryTable({ leaveData, employees, removeLeave, holidays }) {
  const curYear = new Date().getFullYear();
  const [filterEmp, setFilterEmp] = useState("Tous");
  const [filterYear, setFilterYear] = useState(String(curYear));
  const [filterMonth, setFilterMonth] = useState("Tous");

  const MONTHS = ["01","02","03","04","05","06","07","08","09","10","11","12"];
  const MONTH_NAMES = ["Janvier","Février","Mars","Avril","Mai","Juin","Juillet","Août","Septembre","Octobre","Novembre","Décembre"];

  const allRecords = leaveData.flatMap(({name, records}) => records.map(r => ({...r, empName: name})));
  const years = [...new Set(allRecords.map(r => r.start?.slice(0,4)).filter(Boolean))].sort((a,b)=>b-a);
  if (!years.includes(String(curYear))) years.unshift(String(curYear));

  const filtered = allRecords.filter(r =>
    (filterEmp === "Tous" || r.empName === filterEmp) &&
    (filterYear === "Tous" || r.start?.startsWith(filterYear)) &&
    (filterMonth === "Tous" || filterYear === "Tous" || r.start?.slice(5,7) === filterMonth)
  );

  const enPoste = employees.filter(e => e.employed);
  const aQuitte = employees.filter(e => !e.employed);
  const sel = {padding:"7px 10px", border:"1px solid #cbd5e1", borderRadius:6, fontSize:13, background:"#f8fafc", cursor:"pointer"};

  return (
    <div style={{ background:"#fff", borderRadius:10, padding:18, boxShadow:"0 1px 3px #0001" }}>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:14, flexWrap:"wrap", gap:10 }}>
        <h2 style={{ margin:0, fontSize:14 }}>📋 Historique complet</h2>
        <div style={{ display:"flex", gap:8, alignItems:"center", flexWrap:"wrap" }}>
          <select value={filterEmp} onChange={e=>setFilterEmp(e.target.value)} style={sel}>
            <option value="Tous">👥 Tous les employés</option>
            {enPoste.length > 0 && <optgroup label="🏢 En poste">
              {enPoste.map(e=><option key={e.name} value={e.name}>{e.name}</option>)}
            </optgroup>}
            {aQuitte.length > 0 && <optgroup label="🚪 A quitté">
              {aQuitte.map(e=><option key={e.name} value={e.name}>{e.name}</option>)}
            </optgroup>}
          </select>
          <select value={filterYear} onChange={e=>{ setFilterYear(e.target.value); setFilterMonth("Tous"); }} style={sel}>
            <option value="Tous">📅 Toutes les années</option>
            {years.map(y=><option key={y}>{y}</option>)}
          </select>
          {filterYear !== "Tous" && (
            <select value={filterMonth} onChange={e=>setFilterMonth(e.target.value)} style={sel}>
              <option value="Tous">📆 Tous les mois</option>
              {MONTHS.map((m,i)=><option key={m} value={m}>{MONTH_NAMES[i]}</option>)}
            </select>
          )}
          {(filterEmp!=="Tous"||filterYear!==String(curYear)||filterMonth!=="Tous") &&
            <button onClick={()=>{setFilterEmp("Tous");setFilterYear(String(curYear));setFilterMonth("Tous");}}
              style={{ background:"#fee2e2", border:"none", borderRadius:6, padding:"7px 10px", fontSize:12, color:"#dc2626", cursor:"pointer", fontWeight:600 }}>✕ Reset</button>}
        </div>
      </div>
      {filtered.length===0 ? (
        <div style={{ color:"#94a3b8", textAlign:"center", padding:24 }}>Aucun congé trouvé</div>
      ) : (
        <>
          <table style={{ width:"100%", borderCollapse:"collapse", fontSize:13 }}>
            <thead><tr style={{ background:"#f1f5f9" }}>
              {["Employé","Type","Début","Fin","Jours","Statut",""].map(h=><th key={h} style={{ padding:"8px 10px", textAlign:"left", color:"#475569", fontWeight:600, fontSize:12 }}>{h}</th>)}
            </tr></thead>
            <tbody>
              {filtered.map(r=>(
                <tr key={r.id} style={{ borderBottom:"1px solid #f1f5f9" }}>
                  <td style={{ padding:"7px 10px", fontWeight:600 }}>
                    {r.empName}
                    {(()=>{ const e=employees.find(x=>x.name===r.empName); return e&&!e.employed?<span style={{ marginLeft:4, padding:"1px 5px", borderRadius:99, fontSize:9, fontWeight:700, background:"#fff7ed", color:"#ea580c" }}>🚪 quitté</span>:null; })()}
                  </td>
                  <td style={{ padding:"7px 10px" }}><span style={{ padding:"2px 8px", borderRadius:99, fontSize:11, fontWeight:600, background:r.type==="Maladie"?"#faf5ff":"#eff6ff", color:r.type==="Maladie"?"#7c3aed":"#1e40af" }}>{r.type}</span></td>
                  <td style={{ padding:"7px 10px" }}>{r.start}{r.halfDay&&<span style={{ marginLeft:4, padding:"1px 5px", borderRadius:99, fontSize:10, fontWeight:700, background:"#fef9c3", color:"#ca8a04" }}>½ j</span>}</td>
                  <td style={{ padding:"7px 10px" }}>{r.halfDay?"-":r.end}</td>
                  <td style={{ padding:"7px 10px", fontWeight:700, color:"#1e40af" }}>{getRecordDays(r,holidays)}</td>
                  <td style={{ padding:"7px 10px" }}><Badge s={r.status}/></td>
                  <td style={{ padding:"7px 10px" }}><button onClick={()=>removeLeave(r.empName,r.id)} style={{ background:"none", border:"none", cursor:"pointer", fontSize:15 }}>🗑️</button></td>
                </tr>
              ))}
            </tbody>
          </table>
          <div style={{ marginTop:10, fontSize:12, color:"#94a3b8" }}>
            {filtered.length} entrée(s) · {filtered.reduce((s,r)=>s+getRecordDays(r,holidays),0)} jours ouvrables total
          </div>
        </>
      )}
    </div>
  );
}


export default function App() {
  const [view, setView] = useState("home");
  const [adminPin, setAdminPin] = useState("0000");
  const [pinForm, setPinForm] = useState({ current:"", newPin:"", confirm:"" });
  const [pinMsg, setPinMsg] = useState(null);
  const [adminErr, setAdminErr] = useState("");
  const [params, setParams] = useState(initParams);
  const [employees, setEmployees] = useState(initEmployees);
  const [leaveData, setLeaveData] = useState(initLeaves);
  const [refDate, setRefDate] = useState(fmt(TODAY));
  const [form, setForm] = useState({ empIdx:0, type:LEAVE_TYPES[0], start:"", end:"", status:STATUSES[1], halfDay:false });
  const [msg, setMsg] = useState("");
  const [showAddEmp, setShowAddEmp] = useState(false);
  const [newEmp, setNewEmp] = useState({ name:"", hireDate:fmt(TODAY), pin:"", contractType:"CDI" });
  const [newEmpErr, setNewEmpErr] = useState("");
  const [confirmDel, setConfirmDel] = useState(null); // index à supprimer
  const [editEmp, setEditEmp] = useState(null);
  const [showParams, setShowParams] = useState(false);
  const [holidays, setHolidays] = useState([]);
  const [newHoliday, setNewHoliday] = useState({ date: fmt(TODAY), name: "", paid: true });

  // ── Chargement depuis db.json via json-server ──
  const [loaded, setLoaded] = useState(false);
  const saveTimer = useRef(null);

  useEffect(() => {
    fetch('appState/1')
      .then(r => r.json())
      .then(data => {
        if (data.adminPin) setAdminPin(data.adminPin);
        if (data.params) setParams(data.params);
        if (data.employees) setEmployees(data.employees);
        if (data.leaveData) setLeaveData(data.leaveData);
        if (data.holidays) setHolidays(data.holidays);
        setLoaded(true);
      })
      .catch(() => setLoaded(true));
  }, []);

  useEffect(() => {
    if (!loaded) return;
    clearTimeout(saveTimer.current);
    saveTimer.current = setTimeout(() => {
      fetch('appState/1', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id:1, adminPin, params, employees, leaveData, holidays })
      }).catch(() => {});
    }, 500);
  }, [loaded, adminPin, params, employees, leaveData, holidays]);

  const updateEmp = (i, field, val) => {
    setEmployees(p=>p.map((e,idx)=>idx===i?{...e,[field]:val}:e));
    if (field==="name") setLeaveData(p=>p.map((l,idx)=>idx===i?{...l,name:val}:l));
  };

  const getAcq = hd => +(monthsDiff(hd,refDate)*params.cpRate).toFixed(2);
  const getMalAcq = hd => {
    const refYear = refDate.slice(0,4);
    const startOfYear = `${refYear}-01-01`;
    const malFrom = hd > startOfYear ? hd : startOfYear;
    return +(monthsDiff(malFrom, refDate) * (params.malRate/12)).toFixed(2);
  };
  const getCpPris = name => leaveData.find(l=>l.name===name)?.records.filter(r=>r.type==="Congé payé"&&r.status==="Approuvé").reduce((s,r)=>s+getRecordDays(r,holidays),0)||0;
  const getMalPris = name => {
    const refYear = refDate.slice(0,4);
    return leaveData.find(l=>l.name===name)?.records.filter(r=>r.type==="Maladie"&&r.status==="Approuvé"&&r.start?.startsWith(refYear)).reduce((s,r)=>s+getRecordDays(r,holidays),0)||0;
  };
  const getCpSolde = emp => +(getAcq(emp.hireDate) - getCpPris(emp.name)).toFixed(2);
  const getMalSolde = emp => +(getMalAcq(emp.hireDate) - getMalPris(emp.name)).toFixed(2);

  const addLeave = () => {
    if (!form.start){setMsg("⚠️ Date de début manquante");return;}
    if (!form.halfDay && !form.end){setMsg("⚠️ Date de fin manquante");return;}
    if (!form.halfDay && new Date(form.start)>new Date(form.end)){setMsg("⚠️ Dates invalides");return;}
    const record = form.halfDay ? {...form, end:form.start} : form;
    const empName = employees[form.empIdx].name;
    setLeaveData(p=>p.map(l=>l.name===empName?{...l,records:[...l.records,{...record,id:Date.now()}]}:l));
    setForm(f=>({...f,start:"",end:"",halfDay:false}));
    setMsg("✅ Congé ajouté !"); setTimeout(()=>setMsg(""),2000);
  };

  const removeLeave = (empName, id) => setLeaveData(p=>p.map(l=>l.name===empName?{...l,records:l.records.filter(r=>r.id!==id)}:l));

  const downloadCSV = () => {
    const sep=";", lines=[];
    lines.push("GESTION DES CONGÉS RH 2026");
    lines.push(`Taux CP: ${params.cpRate} j/mois | Taux Maladie: ${params.malRate} j/an | Date réf: ${refDate}`);
    lines.push("");
    lines.push(["Employé","Date embauche","CP Acquis","CP Pris","CP Solde","Mal. Acquis","Mal. Pris","Mal. Solde"].join(sep));
    employees.forEach(emp=>{
      lines.push([emp.name,emp.hireDate,getAcq(emp.hireDate),getCpPris(emp.name),getCpSolde(emp),getMalAcq(emp.hireDate),getMalPris(emp.name),getMalSolde(emp)].join(sep));
    });
    lines.push(""); lines.push("DÉTAIL");
    lines.push(["Employé","Type","Début","Fin","Jours","Statut"].join(sep));
    leaveData.forEach(({name,records})=>records.forEach(r=>lines.push([name,r.type,r.start,r.halfDay?"(demi-journée)":r.end,getRecordDays(r,holidays),r.status].join(sep))));
    const blob=new Blob(["\uFEFF"+lines.join("\n")],{type:"text/csv;charset=utf-8;"});
    const url=URL.createObjectURL(blob); const a=document.createElement("a");
    a.href=url; a.download="RH_Conges_2026.csv"; a.click(); URL.revokeObjectURL(url);
  };

  if (!loaded) return (
    <div style={{ display:"flex", alignItems:"center", justifyContent:"center", height:"100vh", fontFamily:"Segoe UI,sans-serif", flexDirection:"column", gap:14 }}>
      <div style={{ fontSize:48 }}>📋</div>
      <div style={{ fontSize:15, color:"#64748b", fontWeight:600 }}>Chargement des données…</div>
      <div style={{ fontSize:12, color:"#94a3b8" }}>Connexion à json-server en cours</div>
    </div>
  );

  if (view==="employee") return <EmployeeLogin employees={employees} leaveData={leaveData} refDate={refDate} params={params} holidays={holidays} onBack={()=>setView("home")} />;
  if (view==="adminLogin") return (
    <div style={{ fontFamily:"Segoe UI,sans-serif", maxWidth:400, margin:"60px auto", padding:24 }}>
      <div style={{ background:"#fff", borderRadius:14, padding:32, boxShadow:"0 4px 24px #0002", textAlign:"center" }}>
        <div style={{ fontSize:46, marginBottom:8 }}>🛡️</div>
        <h2 style={{ margin:"0 0 4px", color:"#1e293b" }}>Espace Admin</h2>
        <p style={{ color:"#64748b", fontSize:13, marginBottom:22 }}>Entrez le code administrateur</p>
        <input type="password" placeholder="🔑 PIN Admin" id="adminPin"
          onKeyDown={e=>{
            if(e.key==="Enter"){
              if(e.target.value===adminPin){setView("admin");e.target.value="";}
              else{setAdminErr("❌ Code incorrect.");}
            }
          }}
          onChange={()=>setAdminErr("")}
          style={{ width:"100%", padding:"10px 12px", border:"1px solid #cbd5e1", borderRadius:8, fontSize:14, marginBottom:14, boxSizing:"border-box", textAlign:"center", letterSpacing:6 }} />
        {adminErr&&<div style={{ color:"#dc2626", fontSize:13, marginBottom:10 }}>{adminErr}</div>}
        <button onClick={()=>{
          const v=document.getElementById("adminPin").value;
          if(v===adminPin){setView("admin");document.getElementById("adminPin").value="";}
          else setAdminErr("❌ Code incorrect.");
        }} style={{ width:"100%", background:"#1e40af", color:"#fff", border:"none", borderRadius:8, padding:12, fontWeight:700, fontSize:15, cursor:"pointer" }}>Accéder →</button>
        <button onClick={()=>setView("home")} style={{ marginTop:12, background:"none", border:"none", color:"#94a3b8", cursor:"pointer", fontSize:13 }}>← Retour</button>
      </div>
    </div>
  );
  if (view==="home") return (
    <div style={{ fontFamily:"Segoe UI,sans-serif", maxWidth:440, margin:"80px auto", padding:24 }}>
      <div style={{ background:"linear-gradient(135deg,#1e40af,#3b82f6)", borderRadius:16, padding:"32px 28px", textAlign:"center", color:"#fff", boxShadow:"0 8px 32px #1e40af44" }}>
        <div style={{ fontSize:52, marginBottom:10 }}>📊</div>
        <h1 style={{ margin:"0 0 6px", fontSize:22 }}>Gestion des Congés RH</h1>
        <p style={{ margin:"0 0 32px", opacity:.8, fontSize:13 }}>Choisissez votre espace</p>
        <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
          <button onClick={()=>setView("adminLogin")} style={{ background:"#fff", color:"#1e40af", border:"none", borderRadius:10, padding:"14px", fontWeight:800, fontSize:16, cursor:"pointer", boxShadow:"0 2px 8px #0002" }}>
            🛡️ Espace Admin
          </button>
          <button onClick={()=>setView("employee")} style={{ background:"rgba(255,255,255,0.15)", color:"#fff", border:"2px solid rgba(255,255,255,0.4)", borderRadius:10, padding:"14px", fontWeight:700, fontSize:16, cursor:"pointer" }}>
            👤 Portail Employé
          </button>
        </div>

      </div>
    </div>
  );

  return (
    <div style={{ fontFamily:"Segoe UI,sans-serif", maxWidth:980, margin:"0 auto", padding:24, background:"#f0f4f8", minHeight:"100vh" }}>

      {/* Header */}
      <div style={{ background:"linear-gradient(135deg,#1e40af,#3b82f6)", borderRadius:14, padding:"18px 24px", marginBottom:18, display:"flex", justifyContent:"space-between", alignItems:"center" }}>
        <div>
          <h1 style={{ color:"#fff", margin:0, fontSize:19 }}>📊 RH — Gestion des Congés</h1>
          <p style={{ color:"#bfdbfe", margin:"3px 0 0", fontSize:12 }}>CP : {params.cpRate} j/mois · Maladie : {params.malRate} j/an (non payé si dépassé)</p>
        </div>
        <div style={{ display:"flex", gap:8 }}>
          <button onClick={()=>setShowParams(!showParams)} style={{ background:"#f59e0b", color:"#fff", border:"none", borderRadius:8, padding:"9px 14px", cursor:"pointer", fontWeight:700, fontSize:12 }}>⚙️ Paramètres</button>
          <button onClick={()=>setView("home")} style={{ background:"#7c3aed", color:"#fff", border:"none", borderRadius:8, padding:"9px 14px", cursor:"pointer", fontWeight:700, fontSize:12 }}>👤 Portail Employé</button>
          <button onClick={downloadCSV} style={{ background:"#16a34a", color:"#fff", border:"none", borderRadius:8, padding:"9px 14px", cursor:"pointer", fontWeight:700, fontSize:12 }}>⬇️ Export Excel</button>
        </div>
      </div>

      {/* Paramètres */}
      {showParams && (
        <div style={{ background:"#fff", borderRadius:10, padding:18, marginBottom:16, boxShadow:"0 1px 3px #0001", border:"2px solid #fbbf24" }}>
          <h2 style={{ margin:"0 0 14px", fontSize:14, color:"#92400e" }}>⚙️ Paramètres d'accumulation</h2>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:16 }}>
            <div>
              <label style={{ fontSize:12, color:"#64748b", display:"block", marginBottom:4 }}>🌴 Taux CP (jours / mois)</label>
              <input type="number" step="0.25" min="0" value={params.cpRate} onChange={e=>setParams(p=>({...p,cpRate:+e.target.value}))}
                style={{ width:"100%", padding:"8px 10px", border:"2px solid #3b82f6", borderRadius:6, fontSize:15, fontWeight:700, color:"#1e40af", boxSizing:"border-box" }} />
              <div style={{ fontSize:11, color:"#94a3b8", marginTop:3 }}>= {+(params.cpRate*12).toFixed(2)} jours/an</div>
            </div>
            <div>
              <label style={{ fontSize:12, color:"#64748b", display:"block", marginBottom:4 }}>🏥 Taux Maladie (jours / an)</label>
              <input type="number" step="0.5" min="0" value={params.malRate} onChange={e=>setParams(p=>({...p,malRate:+e.target.value}))}
                style={{ width:"100%", padding:"8px 10px", border:"2px solid #7c3aed", borderRadius:6, fontSize:15, fontWeight:700, color:"#7c3aed", boxSizing:"border-box" }} />
              <div style={{ fontSize:11, color:"#94a3b8", marginTop:3 }}>Progressif : {+(params.malRate/12).toFixed(4)} j/mois → 3j en 12 mois</div>
            </div>
            <div>
              <label style={{ fontSize:12, color:"#64748b", display:"block", marginBottom:4 }}>📅 Date de référence</label>
              <div style={{ display:"flex", gap:6 }}>
                <input type="date" value={refDate} onChange={e=>setRefDate(e.target.value)}
                  style={{ flex:1, padding:"8px 10px", border:"2px solid #16a34a", borderRadius:6, fontSize:13, fontWeight:600, color:"#15803d", boxSizing:"border-box" }} />
                {refDate !== fmt(TODAY) && (
                  <button onClick={()=>setRefDate(fmt(TODAY))}
                    title="Revenir à aujourd'hui"
                    style={{ padding:"8px 12px", background:"#16a34a", color:"#fff", border:"none", borderRadius:6, fontSize:12, fontWeight:700, cursor:"pointer", whiteSpace:"nowrap" }}>
                    ↺ Aujourd'hui
                  </button>
                )}
              </div>
              <div style={{ fontSize:11, color:"#94a3b8", marginTop:3 }}>Pour simulation future/passée</div>
            </div>
          </div>

          {/* Modifier PIN admin */}
          <div style={{ borderTop:"1px solid #fde68a", marginTop:18, paddingTop:16 }}>
            <div style={{ fontSize:13, fontWeight:700, color:"#92400e", marginBottom:10 }}>🔑 Modifier le PIN administrateur</div>
            <div style={{ display:"flex", gap:8, flexWrap:"wrap", alignItems:"center" }}>
              <input type="password" placeholder="PIN actuel" value={pinForm.current} onChange={e=>setPinForm(p=>({...p,current:e.target.value}))}
                style={{ padding:"6px 10px", border:"1px solid #cbd5e1", borderRadius:6, fontSize:13, width:120 }} />
              <input type="password" placeholder="Nouveau PIN" value={pinForm.newPin} onChange={e=>setPinForm(p=>({...p,newPin:e.target.value}))}
                style={{ padding:"6px 10px", border:"1px solid #cbd5e1", borderRadius:6, fontSize:13, width:130 }} />
              <input type="password" placeholder="Confirmer" value={pinForm.confirm} onChange={e=>setPinForm(p=>({...p,confirm:e.target.value}))}
                style={{ padding:"6px 10px", border:"1px solid #cbd5e1", borderRadius:6, fontSize:13, width:120 }} />
              <button onClick={()=>{
                if(pinForm.current!==adminPin){setPinMsg({ok:false,txt:"❌ PIN actuel incorrect."});return;}
                if(!pinForm.newPin.trim()){setPinMsg({ok:false,txt:"❌ Le nouveau PIN est vide."});return;}
                if(pinForm.newPin!==pinForm.confirm){setPinMsg({ok:false,txt:"❌ Les deux nouveaux PINs ne correspondent pas."});return;}
                setAdminPin(pinForm.newPin);
                setPinForm({current:"",newPin:"",confirm:""});
                setPinMsg({ok:true,txt:"✅ PIN modifié avec succès."});
                setTimeout(()=>setPinMsg(null),3000);
              }} style={{ padding:"6px 16px", background:"#1e40af", color:"#fff", border:"none", borderRadius:6, cursor:"pointer", fontWeight:700, fontSize:12 }}>Mettre à jour</button>
            </div>
            {pinMsg&&<div style={{ marginTop:7, fontSize:12, fontWeight:600, color:pinMsg.ok?"#16a34a":"#dc2626" }}>{pinMsg.txt}</div>}
          </div>

          {/* Jours fériés */}
          <div style={{ borderTop:"1px solid #fde68a", marginTop:18, paddingTop:16 }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:10, flexWrap:"wrap", gap:8 }}>
              <span style={{ fontSize:13, fontWeight:700, color:"#92400e" }}>🗓️ Jours Fériés ({holidays.length})</span>
              <div style={{ display:"flex", gap:6, alignItems:"center", flexWrap:"wrap" }}>
                <input type="date" value={newHoliday.date} onChange={e=>setNewHoliday(p=>({...p,date:e.target.value}))}
                  style={{ padding:"5px 8px", border:"1px solid #cbd5e1", borderRadius:5, fontSize:12 }} />
                <input value={newHoliday.name} onChange={e=>setNewHoliday(p=>({...p,name:e.target.value}))}
                  placeholder="Nom du jour férié"
                  style={{ padding:"5px 8px", border:"1px solid #cbd5e1", borderRadius:5, fontSize:12, width:170 }} />
                <button onClick={()=>setNewHoliday(p=>({...p,paid:!p.paid}))}
                  style={{ padding:"5px 12px", borderRadius:5, border:"2px solid", cursor:"pointer", fontSize:11, fontWeight:700,
                    borderColor:newHoliday.paid?"#16a34a":"#dc2626", background:newHoliday.paid?"#dcfce7":"#fee2e2", color:newHoliday.paid?"#15803d":"#b91c1c" }}>
                  {newHoliday.paid?"✅ Payé":"❌ Non payé"}
                </button>
                <button onClick={()=>{
                  if(!newHoliday.date||!newHoliday.name.trim()) return;
                  if(holidays.find(h=>h.date===newHoliday.date)) return;
                  setHolidays(p=>[...p,{...newHoliday,id:Date.now()}].sort((a,b)=>a.date.localeCompare(b.date)));
                  setNewHoliday({date:fmt(TODAY),name:"",paid:true});
                }} style={{ padding:"5px 14px", background:"#f59e0b", color:"#fff", border:"none", borderRadius:5, cursor:"pointer", fontWeight:700, fontSize:12 }}>+ Ajouter</button>
              </div>
            </div>
            {holidays.length === 0 ? (
              <div style={{ color:"#94a3b8", fontSize:12, fontStyle:"italic" }}>Aucun jour férié configuré — samedis &amp; dimanches exclus automatiquement.</div>
            ) : (
              <div style={{ display:"flex", flexWrap:"wrap", gap:6 }}>
                {holidays.map(h=>(
                  <div key={h.id} style={{ display:"flex", alignItems:"center", gap:5, background:h.paid?"#f0fdf4":"#fff1f2", border:`1px solid ${h.paid?"#bbf7d0":"#fecaca"}`, borderRadius:7, padding:"4px 10px" }}>
                    <span style={{ fontSize:11, color:"#64748b", fontWeight:600 }}>{h.date}</span>
                    <span style={{ fontSize:11, color:"#1e293b", fontWeight:700 }}>{h.name}</span>
                    <span onClick={()=>setHolidays(p=>p.map(x=>x.id===h.id?{...x,paid:!x.paid}:x))}
                      style={{ padding:"1px 7px", borderRadius:99, fontSize:10, fontWeight:700, cursor:"pointer",
                        background:h.paid?"#dcfce7":"#fee2e2", color:h.paid?"#16a34a":"#dc2626", border:`1px solid ${h.paid?"#86efac":"#fca5a5"}` }}>
                      {h.paid?"Payé":"Non payé"}
                    </span>
                    <button onClick={()=>setHolidays(p=>p.filter(x=>x.id!==h.id))}
                      style={{ background:"none", border:"none", cursor:"pointer", color:"#dc2626", fontSize:14, lineHeight:1, padding:"0 2px" }}>✕</button>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      {/* Confirmation suppression */}
      {confirmDel !== null && (
        <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.4)", zIndex:999, display:"flex", alignItems:"center", justifyContent:"center" }}>
          <div style={{ background:"#fff", borderRadius:12, padding:28, maxWidth:360, width:"90%", textAlign:"center", boxShadow:"0 8px 32px #0003" }}>
            <div style={{ fontSize:40, marginBottom:10 }}>⚠️</div>
            <h3 style={{ margin:"0 0 8px", color:"#1e293b" }}>Supprimer {employees[confirmDel]?.name} ?</h3>
            <p style={{ color:"#64748b", fontSize:13, marginBottom:20 }}>Tout l'historique sera effacé définitivement.</p>
            <div style={{ display:"flex", gap:10 }}>
              <button onClick={()=>setConfirmDel(null)}
                style={{ flex:1, padding:"10px", background:"#f1f5f9", border:"none", borderRadius:8, fontWeight:600, cursor:"pointer", color:"#475569" }}>
                Annuler
              </button>
              <button onClick={()=>{
                const name = employees[confirmDel].name;
                setEmployees(p=>p.filter((_,idx)=>idx!==confirmDel));
                setLeaveData(p=>p.filter(l=>l.name!==name));
                if(editEmp===confirmDel) setEditEmp(null);
                setConfirmDel(null);
              }} style={{ flex:1, padding:"10px", background:"#dc2626", border:"none", borderRadius:8, fontWeight:700, cursor:"pointer", color:"#fff" }}>
                Supprimer
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Cartes employés – 2 groupes */}
      {(()=>{
        const activeEmps = employees.map((emp,i)=>({emp,i})).filter(({emp})=>emp.employed);
        const leftEmps   = employees.map((emp,i)=>({emp,i})).filter(({emp})=>!emp.employed);
        const renderCard = ({emp,i}) => {
          const cpS=getCpSolde(emp), malS=getMalSolde(emp);
          const isEdit = editEmp===i;
          const isLeft = !emp.employed;
          const isInactive = !emp.active;
          const cardBorder = isEdit?"2px solid #3b82f6":isLeft?"2px solid #f97316":isInactive?"2px solid #94a3b8":"2px solid transparent";
          const currentContract = emp.contracts&&emp.contracts.length>0 ? emp.contracts[emp.contracts.length-1] : null;
          return (
            <div key={i} style={{ background:isLeft?"#fff7ed":isInactive?"#f8fafc":"#fff", borderRadius:10, padding:14, boxShadow:"0 1px 3px #0001", border:cardBorder, opacity:isLeft?0.85:1 }}>
              {/* Header ligne */}
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:6 }}>
                <div style={{ flex:1, minWidth:0 }}>
                  <div style={{ fontWeight:700, fontSize:13, color:"#1e293b", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{emp.name}</div>
                  <div style={{ display:"flex", gap:4, marginTop:3, flexWrap:"wrap", alignItems:"center" }}>
                    <span style={{ padding:"1px 6px", borderRadius:99, fontSize:10, fontWeight:700,
                      background:isInactive?"#f1f5f9":"#dcfce7", color:isInactive?"#64748b":"#16a34a" }}>
                      {isInactive?"⛔ Inactif":"✅ Actif"}
                    </span>
                    <span style={{ padding:"1px 6px", borderRadius:99, fontSize:10, fontWeight:700,
                      background:isLeft?"#fff7ed":"#eff6ff", color:isLeft?"#ea580c":"#1e40af" }}>
                      {isLeft?"🚪 A quitté":"🏢 En poste"}
                    </span>
                    {currentContract && <ContractBadge type={currentContract.type} />}
                  </div>
                </div>
                <div style={{ display:"flex", gap:3, marginLeft:4, flexShrink:0 }}>
                  <button onClick={()=>setEditEmp(isEdit?null:i)}
                    style={{ background:isEdit?"#dbeafe":"#f1f5f9", border:"none", borderRadius:5, padding:"3px 7px", cursor:"pointer", fontSize:11, fontWeight:600, color:isEdit?"#1e40af":"#64748b" }}>
                    {isEdit?"✓":"✏️"}
                  </button>
                  <button onClick={()=>setConfirmDel(i)}
                    style={{ background:"#fee2e2", border:"none", borderRadius:5, padding:"3px 7px", cursor:"pointer", fontSize:11, fontWeight:600, color:"#dc2626" }}>🗑️</button>
                </div>
              </div>

              {isEdit ? (
                <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
                  <Input label="Nom" value={emp.name} onChange={e=>updateEmp(i,"name",e.target.value)} />
                  <Input label="Date embauche" type="date" value={emp.hireDate} onChange={e=>updateEmp(i,"hireDate",e.target.value)} />
                  <Input label="PIN (4 chiffres)" type="password" maxLength={4} placeholder="****"
                    onBlur={e=>e.target.value.length===4&&updateEmp(i,"pin",e.target.value)}
                    style={{ letterSpacing:4, textAlign:"center" }} />
                  <div style={{ fontSize:10, color:"#94a3b8", textAlign:"center" }}>PIN actuel : {emp.pin}</div>

                  {/* Toggles */}
                  <div style={{ display:"flex", gap:6 }}>
                    <button onClick={()=>{
                      const nowActive = !emp.active;
                      updateEmp(i,"active",nowActive);
                      updateEmp(i,"employed",nowActive);
                      updateEmp(i,"leaveDate",nowActive?"":fmt(TODAY));
                    }} style={{ flex:1, padding:"5px", fontSize:11, fontWeight:700, borderRadius:6, border:"none", cursor:"pointer",
                        background:emp.active?"#dcfce7":"#f1f5f9", color:emp.active?"#16a34a":"#64748b" }}>
                      {emp.active?"✅ Actif":"⛔ Inactif"}
                    </button>
                    <button onClick={()=>{
                      const nowEmployed = !emp.employed;
                      updateEmp(i,"employed",nowEmployed);
                      updateEmp(i,"active",nowEmployed);
                      updateEmp(i,"leaveDate",nowEmployed?"":fmt(TODAY));
                    }} style={{ flex:1, padding:"5px", fontSize:11, fontWeight:700, borderRadius:6, border:"none", cursor:"pointer",
                        background:emp.employed?"#eff6ff":"#fff7ed", color:emp.employed?"#1e40af":"#ea580c" }}>
                      {emp.employed?"🏢 En poste":"🚪 A quitté"}
                    </button>
                  </div>

                  {!emp.employed && (
                    <>
                      <Input label="Date de départ" type="date" value={emp.leaveDate||""}
                        onChange={e=>updateEmp(i,"leaveDate",e.target.value)} />
                      <div>
                        <label style={{ fontSize:11, color:"#64748b", display:"block", marginBottom:3 }}>Cause du départ</label>
                        <input value={emp.leaveCause||""} onChange={e=>updateEmp(i,"leaveCause",e.target.value)}
                          placeholder="Démission, fin de contrat, retraite…"
                          style={{ width:"100%", padding:"7px 10px", border:"1px solid #fed7aa", borderRadius:6, fontSize:12, boxSizing:"border-box", background:"#fff7ed" }} />
                      </div>
                    </>
                  )}

                  {/* Contrats */}
                  <div style={{ borderTop:"1px solid #f1f5f9", paddingTop:8 }}>
                    <div style={{ fontSize:11, fontWeight:700, color:"#475569", marginBottom:6 }}>📄 Historique des contrats</div>
                    {(emp.contracts||[]).map((c,ci)=>(
                      <div key={c.id} style={{ display:"flex", gap:6, alignItems:"center", marginBottom:5, background:"#f8fafc", borderRadius:6, padding:"6px 8px" }}>
                        <select value={c.type} onChange={e=>updateEmp(i,"contracts",(emp.contracts||[]).map((x,xi)=>xi===ci?{...x,type:e.target.value}:x))}
                          style={{ padding:"3px 5px", border:"1px solid #cbd5e1", borderRadius:5, fontSize:11, fontWeight:700, color:CONTRACT_COLORS[c.type]?.c||"#64748b", background:CONTRACT_COLORS[c.type]?.bg||"#f8fafc", cursor:"pointer" }}>
                          {CONTRACT_TYPES.map(t=><option key={t}>{t}</option>)}
                        </select>
                        <input type="date" value={c.startDate} onChange={e=>updateEmp(i,"contracts",(emp.contracts||[]).map((x,xi)=>xi===ci?{...x,startDate:e.target.value}:x))}
                          style={{ flex:1, padding:"3px 5px", border:"1px solid #cbd5e1", borderRadius:5, fontSize:11, boxSizing:"border-box" }} />
                        <span style={{ fontSize:10, color:"#94a3b8" }}>→</span>
                        <input type="date" value={c.endDate||""} placeholder="En cours" onChange={e=>updateEmp(i,"contracts",(emp.contracts||[]).map((x,xi)=>xi===ci?{...x,endDate:e.target.value}:x))}
                          style={{ flex:1, padding:"3px 5px", border:"1px solid #cbd5e1", borderRadius:5, fontSize:11, boxSizing:"border-box" }} />
                        <input value={c.note||""} placeholder="Note" onChange={e=>updateEmp(i,"contracts",(emp.contracts||[]).map((x,xi)=>xi===ci?{...x,note:e.target.value}:x))}
                          style={{ flex:1.5, padding:"3px 5px", border:"1px solid #cbd5e1", borderRadius:5, fontSize:11, boxSizing:"border-box" }} />
                        <button onClick={()=>updateEmp(i,"contracts",(emp.contracts||[]).filter((_,xi)=>xi!==ci))}
                          style={{ background:"none", border:"none", cursor:"pointer", fontSize:13, color:"#dc2626", padding:"0 2px" }}>✕</button>
                      </div>
                    ))}
                    <button onClick={()=>updateEmp(i,"contracts",[...(emp.contracts||[]),{ id:Date.now(), type:"CDD", startDate:fmt(TODAY), endDate:"", note:"" }])}
                      style={{ fontSize:11, padding:"4px 10px", background:"#eff6ff", color:"#1e40af", border:"1px solid #bfdbfe", borderRadius:6, cursor:"pointer", fontWeight:600 }}>
                      + Ajouter un contrat
                    </button>
                  </div>
                </div>
              ) : (
                <>
                  <div style={{ fontSize:11, color:"#94a3b8", marginBottom:4 }}>
                    📅 {emp.hireDate} · {monthsDiff(emp.hireDate, emp.leaveDate||refDate)} mois
                    {emp.leaveDate && <span style={{ color:"#ea580c", marginLeft:4 }}>→ {emp.leaveDate}</span>}
                  </div>
                  {emp.leaveCause && (
                    <div style={{ fontSize:10, color:"#ea580c", marginBottom:4, background:"#fff7ed", borderRadius:5, padding:"2px 6px", display:"inline-block" }}>Motif : {emp.leaveCause}</div>
                  )}
                  {emp.contracts && emp.contracts.length > 1 && (
                    <div style={{ display:"flex", gap:3, flexWrap:"wrap", marginBottom:6 }}>
                      {emp.contracts.map((c,ci)=>(
                        <span key={ci} style={{ fontSize:10, padding:"1px 6px", borderRadius:99, background:CONTRACT_COLORS[c.type]?.bg||"#f8fafc", color:CONTRACT_COLORS[c.type]?.c||"#64748b", border:`1px solid ${CONTRACT_COLORS[c.type]?.c||"#94a3b8"}33`, fontWeight:700 }}>
                          {c.type}{c.endDate?"":" ✔"}
                        </span>
                      ))}
                    </div>
                  )}
                  <div style={{ background:isLeft?"#fef3c7":"#eff6ff", borderRadius:7, padding:"8px 10px", marginBottom:6 }}>
                    <div style={{ fontSize:10, color:isLeft?"#d97706":"#3b82f6", fontWeight:600, marginBottom:2 }}>🌴 CONGÉS PAYÉS</div>
                    <div style={{ fontSize:20, fontWeight:800, color:cpS<0?"#dc2626":isLeft?"#d97706":"#1e40af" }}>{cpS} <span style={{ fontSize:11, fontWeight:400, color:"#64748b" }}>j restants</span></div>
                    <div style={{ background:isLeft?"#fde68a":"#dbeafe", borderRadius:99, height:4, marginTop:5 }}>
                      <div style={{ width:`${getAcq(emp.hireDate)>0?Math.min(100,Math.round(getCpPris(emp.name)/getAcq(emp.hireDate)*100)):0}%`, background:isLeft?"#f59e0b":"#3b82f6", height:4, borderRadius:99 }} />
                    </div>
                    <div style={{ fontSize:10, color:"#94a3b8", marginTop:3 }}>{getCpPris(emp.name)} pris / {getAcq(emp.hireDate)} acquis</div>
                  </div>
                  <div style={{ background:"#faf5ff", borderRadius:7, padding:"8px 10px" }}>
                    <div style={{ fontSize:10, color:"#7c3aed", fontWeight:600, marginBottom:2 }}>🏥 MALADIE</div>
                    <div style={{ fontSize:18, fontWeight:800, color:malS<0?"#dc2626":"#7c3aed" }}>{malS} <span style={{ fontSize:11, fontWeight:400, color:"#64748b" }}>j restants</span></div>
                    <div style={{ fontSize:10, color:"#94a3b8", marginTop:3 }}>{getMalPris(emp.name)} pris / {getMalAcq(emp.hireDate)} acquis</div>
                    {malS<0&&<div style={{ fontSize:10, color:"#dc2626", marginTop:2 }}>⚠️ {Math.abs(malS)}j au-delà du solde acquis</div>}
                  </div>
                </>
              )}
            </div>
          );
        };
        return (
          <>
            {/* Groupe 1 : En poste */}
            {activeEmps.length > 0 && (
              <>
                <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:8 }}>
                  <span style={{ fontSize:12, fontWeight:700, color:"#16a34a", background:"#dcfce7", padding:"3px 10px", borderRadius:99 }}>🏢 En poste ({activeEmps.length})</span>
                  <div style={{ flex:1, height:1, background:"#e2e8f0" }}/>
                </div>
                <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(220px,1fr))", gap:12, marginBottom:16 }}>
                  {activeEmps.map(renderCard)}
                </div>
              </>
            )}
            {/* Groupe 2 : A quitté */}
            {leftEmps.length > 0 && (
              <>
                <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:8 }}>
                  <span style={{ fontSize:12, fontWeight:700, color:"#ea580c", background:"#fff7ed", padding:"3px 10px", borderRadius:99 }}>🚪 A quitté ({leftEmps.length})</span>
                  <div style={{ flex:1, height:1, background:"#fed7aa" }}/>
                </div>
                <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(220px,1fr))", gap:12, marginBottom:8 }}>
                  {leftEmps.map(renderCard)}
                </div>
              </>
            )}
          </>
        );
      })()}

      {/* Bouton + formulaire ajout employé */}
      <div style={{ marginBottom:16 }}>
        <button onClick={()=>{ setShowAddEmp(!showAddEmp); setNewEmp({name:"",hireDate:fmt(TODAY),pin:"",contractType:"CDI"}); setNewEmpErr(""); }}
          style={{ background:showAddEmp?"#f1f5f9":"#1e40af", color:showAddEmp?"#475569":"#fff", border:"none", borderRadius:8, padding:"9px 18px", cursor:"pointer", fontWeight:700, fontSize:13 }}>
          {showAddEmp?"✕ Annuler":"➕ Ajouter un employé"}
        </button>
        {showAddEmp && (
          <div style={{ background:"#fff", borderRadius:10, padding:18, marginTop:10, boxShadow:"0 1px 4px #0001", border:"2px solid #3b82f6" }}>
            <h2 style={{ margin:"0 0 14px", fontSize:14, color:"#1e40af" }}>👤 Nouvel employé</h2>
            <div style={{ display:"grid", gridTemplateColumns:"1.5fr 0.8fr 0.8fr 0.8fr auto", gap:10, alignItems:"end" }}>
              <Input label="Nom complet" value={newEmp.name} onChange={e=>setNewEmp(p=>({...p,name:e.target.value}))} placeholder="Nom et prénom" />
              <Input label="Date embauche" type="date" value={newEmp.hireDate} onChange={e=>setNewEmp(p=>({...p,hireDate:e.target.value}))} />
              <div>
                <label style={{ fontSize:11, color:"#64748b", display:"block", marginBottom:3 }}>Type de contrat</label>
                <select value={newEmp.contractType} onChange={e=>setNewEmp(p=>({...p,contractType:e.target.value}))}
                  style={{ width:"100%", padding:"7px 8px", border:"1px solid #cbd5e1", borderRadius:6, fontSize:13, fontWeight:700,
                    color:CONTRACT_COLORS[newEmp.contractType]?.c||"#64748b", background:CONTRACT_COLORS[newEmp.contractType]?.bg||"#f8fafc" }}>
                  {CONTRACT_TYPES.map(t=><option key={t}>{t}</option>)}
                </select>
              </div>
              <Input label="PIN (4 chiffres)" type="password" maxLength={4} placeholder="****"
                value={newEmp.pin} onChange={e=>setNewEmp(p=>({...p,pin:e.target.value}))}
                style={{ letterSpacing:4, textAlign:"center" }} />
              <button onClick={()=>{
                const n = newEmp.name.trim();
                if(!n){setNewEmpErr("⚠️ Nom obligatoire");return;}
                if(employees.find(e=>e.name===n)){setNewEmpErr("⚠️ Nom déjà utilisé");return;}
                if(newEmp.pin.length!==4||!/^\d{4}$/.test(newEmp.pin)){setNewEmpErr("⚠️ PIN doit être 4 chiffres");return;}
                if(!newEmp.hireDate){setNewEmpErr("⚠️ Date d'embauche manquante");return;}
                setEmployees(p=>[...p,{name:n,hireDate:newEmp.hireDate,pin:newEmp.pin,active:true,employed:true,leaveDate:"",leaveCause:"",contracts:[{id:Date.now(),type:newEmp.contractType,startDate:newEmp.hireDate,endDate:"",note:""}]}]);
                setLeaveData(p=>[...p,{name:n,records:[]}]);
                setNewEmp({name:"",hireDate:fmt(TODAY),pin:"",contractType:"CDI"});
                setNewEmpErr("");
                setShowAddEmp(false);
              }} style={{ background:"#16a34a", color:"#fff", border:"none", borderRadius:6, padding:"8px 16px", cursor:"pointer", fontWeight:700, fontSize:13, whiteSpace:"nowrap" }}>✅ Créer</button>
            </div>
            {newEmpErr&&<div style={{ color:"#dc2626", fontSize:12, marginTop:8 }}>{newEmpErr}</div>}
          </div>
        )}
      </div>

      {/* Formulaire */}
      <div style={{ background:"#fff", borderRadius:10, padding:18, marginBottom:16, boxShadow:"0 1px 3px #0001" }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:14 }}>
          <h2 style={{ margin:0, fontSize:14 }}>➕ Ajouter un congé</h2>
          <button onClick={()=>setForm(f=>({...f,halfDay:!f.halfDay,end:f.halfDay?f.end:f.start}))}
            style={{ padding:"5px 14px", borderRadius:99, border:"2px solid", cursor:"pointer", fontSize:12, fontWeight:700,
              borderColor:form.halfDay?"#ca8a04":"#cbd5e1", background:form.halfDay?"#fef9c3":"#f8fafc", color:form.halfDay?"#92400e":"#64748b" }}>
            ½ Demi-journée {form.halfDay?"✓":""}
          </button>
        </div>
        <div style={{ display:"grid", gridTemplateColumns:form.halfDay?"1.5fr 1.2fr 1fr 1.2fr auto":"1.5fr 1.2fr 1fr 1fr 1.2fr auto", gap:10, alignItems:"end" }}>
          {[
            {label:"Employé",key:"empIdx",type:"select",opts:employees.map((e,i)=>({v:i,l:e.name}))},
            {label:"Type",key:"type",type:"select",opts:LEAVE_TYPES.map(o=>({v:o,l:o}))},
            {label:form.halfDay?"Date":"Début",key:"start",type:"date"},
            ...(!form.halfDay?[{label:"Fin",key:"end",type:"date"}]:[]),
            {label:"Statut",key:"status",type:"select",opts:STATUSES.map(o=>({v:o,l:o}))},
          ].map(f=>(
            <div key={f.key}>
              <label style={{ fontSize:11, color:"#64748b", display:"block", marginBottom:3 }}>{f.label}</label>
              {f.type==="select"?(
                <select value={form[f.key]} onChange={e=>setForm(p=>({...p,[f.key]:f.key==="empIdx"?+e.target.value:e.target.value}))}
                  style={{ width:"100%", padding:"7px 8px", border:"1px solid #cbd5e1", borderRadius:6, fontSize:13 }}>
                  {f.opts.map(o=><option key={o.v} value={o.v}>{o.l}</option>)}
                </select>
              ):(
                <input type="date" value={form[f.key]} onChange={e=>setForm(p=>({...p,[f.key]:e.target.value}))}
                  style={{ width:"100%", padding:"7px 8px", border:"1px solid #cbd5e1", borderRadius:6, fontSize:13, boxSizing:"border-box" }} />
              )}
            </div>
          ))}
          <button onClick={addLeave} style={{ background:"#1e40af", color:"#fff", border:"none", borderRadius:6, padding:"8px 16px", cursor:"pointer", fontWeight:700, fontSize:13 }}>Ajouter</button>
        </div>
        {form.start&&(
          form.halfDay
            ?<div style={{ marginTop:8, fontSize:12, color:"#92400e", background:"#fef9c3", borderRadius:6, padding:"5px 10px", display:"inline-block" }}>½ journée le {form.start} = <b>0.5 jour</b></div>
            :form.end&&new Date(form.start)<=new Date(form.end)&&<div style={{ marginTop:8, fontSize:12, color:"#1e40af" }}>📌 Durée : <b>{getWorkingDays(form.start,form.end,new Set(holidays.filter(h=>h.paid).map(h=>h.date)))} jour(s) ouvrable(s)</b></div>
        )}
        {msg&&<div style={{ marginTop:8, fontSize:13, color:msg.startsWith("✅")?"#16a34a":"#dc2626" }}>{msg}</div>}
      </div>

      {/* Tableau historique */}
      <HistoryTable leaveData={leaveData} employees={employees} removeLeave={removeLeave} holidays={holidays} />
    </div>
  );
}